import { combineReducers } from 'redux';

import fetchAllCarriersReducerMap, {
    fetchAllCarriersAction,
} from './actions/fetchAllCarriers';
import fetchCarrierReducerMap, {
    fetchCarrierAction,
} from './actions/fetchCarrier';
import carrierDataReducerMap, {
    selectors as carrierDataSelectors,
} from './appstate';
import fetchAllPoliciesReducerMap, {
    fetchAllPoliciesAction,
} from './policies/actions/fetchAllPolicies';
import fetchPolicyReducerMap, {
    fetchPolicyAction,
} from './policies/actions/fetchPolicy';
import policiesReducerMap, {
    selectors as policiesSelectors,
} from './policies/appstate';
import namespace from './types';

const reducer = combineReducers({
    ...fetchCarrierReducerMap,
    ...fetchAllCarriersReducerMap,
    ...carrierDataReducerMap,
    ...fetchAllPoliciesReducerMap,
    ...fetchPolicyReducerMap,
    ...policiesReducerMap,
});

export {
    carrierDataSelectors,
    fetchAllCarriersAction,
    fetchAllPoliciesAction,
    fetchCarrierAction,
    fetchPolicyAction,
    policiesSelectors,
};

export default {
    [namespace]: reducer,
};
